import api from './api';

export type MediaFolderType = 'image' | 'video' | 'mixed';

export interface MediaFolder {
  id: string;
  user_id: string;
  project_id: string | null;
  type: MediaFolderType;
  name: string;
  color: string | null;
  image_count: number;
  video_count: number;
  created_at: string;
  updated_at: string;
}

export async function listMediaFolders(type?: MediaFolderType): Promise<{ success: true; data: MediaFolder[] }> {
  const res = await api.get('/media-folders', { params: type ? { type } : {} });
  return res.data;
}

export async function createMediaFolder(payload: { name: string; type?: MediaFolderType; color?: string | null }) {
  const res = await api.post('/media-folders', payload);
  return res.data as { success: true; data: MediaFolder };
}

export async function updateMediaFolder(id: string, patch: { name?: string; color?: string | null; type?: MediaFolderType }) {
  const res = await api.put(`/media-folders/${id}`, patch);
  return res.data as { success: true; data: MediaFolder };
}

export async function deleteMediaFolder(id: string) {
  const res = await api.delete(`/media-folders/${id}`);
  return res.data as { success: true };
}

export async function moveMediaToFolder(payload: {
  folder_id: string | null;
  image_ids?: string[];
  video_ids?: string[];
}) {
  const res = await api.post('/media-folders/move', payload);
  return res.data as { success: true; data: { images_moved: number; videos_moved: number } };
}
